import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitter,
  faInstagram,
  faFacebook,
} from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import { LangLink } from '../common/LangLink';
// Import logos
import logoLight from '/images/logo.svg';
import logoDark from '/images/logo-dark.svg';
import { useState, useEffect } from 'react';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const [darkMode, setDarkMode] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setDarkMode(document.documentElement.classList.contains('dark'));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <footer className="bg-neutral-100 dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container-main py-8 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <LangLink to="/" className="inline-flex items-center gap-3">
              <img
                src={darkMode ? logoDark : logoLight}
                alt={`${t('common.appName')} logo`}
                className="h-8 w-auto"
              />
              <span className="font-display font-bold text-2xl text-neutral-900 dark:text-white">
                Unloquea
              </span>
            </LangLink>
            <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-2">
              {t('footer.copyright', { year: currentYear })}
            </p>
          </div>
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-neutral-600 dark:text-neutral-300">
            <LangLink
              to="/terms"
              className="hover:text-primary transition-colors"
            >
              {t('footer.terms')}
            </LangLink>
            <LangLink
              to="/privacy"
              className="hover:text-primary transition-colors"
            >
              {t('footer.privacy')}
            </LangLink>
            <LangLink
              to="/dmca"
              className="hover:text-primary transition-colors"
            >
              {t('footer.dmca')}
            </LangLink>
            <LangLink
              to="/support"
              className="hover:text-primary transition-colors"
            >
              {t('footer.support')}
            </LangLink>
            {/* <LangLink
              to="/faq"
              className="hover:text-primary transition-colors"
            >
              {t('footer.faq')}
            </LangLink> */}
          </nav>
          <div className="flex items-center gap-4">
            <a
              href="https://x.com/unloquea"
              aria-label="Twitter"
              className="text-neutral-500 hover:text-primary transition-colors"
            >
              <FontAwesomeIcon icon={faTwitter} size="lg" />
            </a>
            <a
              href="https://instagram.com/unloquea"
              aria-label="Instagram"
              className="text-neutral-500 hover:text-primary transition-colors"
            >
              <FontAwesomeIcon icon={faInstagram} size="lg" />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              className="text-neutral-500 hover:text-primary transition-colors"
            >
              <FontAwesomeIcon icon={faFacebook} size="lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
